import { render, staticRenderFns } from "./ConsultarPaquetes.vue?vue&type=template&id=02e12bb2&scoped=true"
import script from "./ConsultarPaquetes.vue?vue&type=script&lang=js"
export * from "./ConsultarPaquetes.vue?vue&type=script&lang=js"
import style0 from "./ConsultarPaquetes.vue?vue&type=style&index=0&id=02e12bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e12bb2",
  null
  
)

export default component.exports